import React from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { MessageDescriptor, useIntl } from 'react-intl';
import PageUtils from '../../../utils/pageUtils';
import Service from '../../../interfaces/output/service';
import ServiceFilters from '../../../interfaces/output/serviceFilters';
import { fetchServices, getServices, isLoadingServices, resetServices } from '../../../reducers/serviceReducer';

interface IServicePickerProps {
    value?: Service;
    onChange: any;
    placeholder: MessageDescriptor;
}

const ServicePicker = (props: IServicePickerProps): JSX.Element => {
    const { value, onChange, placeholder } = props;
    const paging = PageUtils.getMaxPaging();
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const [inputValue, setInputValue] = React.useState('');
    const propsIsLoadingServices = useSelector(isLoadingServices);
    const services = useSelector(getServices).content;

    return (
        <Autocomplete
            value={value || null}
            onChange={(e, value: any) => onChange(value)}
            getOptionLabel={(option: Service) => option.serviceDescription || ''}
            inputValue={inputValue}
            onInputChange={(event, newInputvalue: any) => {
                setInputValue(newInputvalue);
                if(!newInputvalue) {
                    onChange(null);
                    dispatch(resetServices());
                }
                if(newInputvalue.length > 2) {
                    dispatch(fetchServices({ paging,
                        filters: {
                            serviceDescription: newInputvalue
                        } as ServiceFilters }));
                }
            }}
            filterOptions={(x) => x}
            options={services}
            loading={propsIsLoadingServices}
            isOptionEqualToValue={(option: Service, value: Service) => option.id === value.id}
            renderInput={(params) => <>
                <TextField {...params} variant="standard" label={placeholder ? formatMessage(placeholder) : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {propsIsLoadingServices ? <CircularProgress color="inherit" size={20} sx={{ position: 'absolute',
                                    right: 20 }}/> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        )
                    }} />
            </>}
        />
    );
};
  
export default ServicePicker;